import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../../../Constants';
import ViolationsForm from './ViolationsEntryForm';
import ViolationsTable from './ViolationsTable';
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";

export default function ViolationsEntryPage() {
  const navHeight = useSelector(selectNavHeight);

  const [selectedInspectionId, setSelectedInspectionId] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [violations, setViolations] = useState([]);
  const [inspections, setInspections] = useState([]);
  const [devices, setDevices] = useState([]);

  // 1) Fetch all inspections once
  useEffect(() => {
    const fetchInspections = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/inspections`, {
          credentials: 'include',
        });
        if (!res.ok) {
          throw new Error(`Failed to fetch inspections. Status: ${res.status}`);
        }
        const data = await res.json();
        setInspections(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Error fetching inspections:', err);
        setInspections([]);
      }
    };
    fetchInspections();
  }, []);

  // 2) If user picks an inspection => fetch devices
  const handleSelectInspection = async (inspId) => {
    setSelectedInspectionId(inspId);
    setSelectedDeviceId('');
    setDevices([]);
    setViolations([]); // optionally clear the table

    if (!inspId) return;
    try {
      const url = `${API_BASE_URL}/api/inspections/id/${inspId}/devices`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) {
        throw new Error(`Failed to fetch devices. Status: ${res.status}`);
      }
      const data = await res.json();
      setDevices(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching devices:', err);
      setDevices([]);
    }
  };

  // 3) If user picks a device => store it
  const handleSelectDevice = (devId) => {
    setSelectedDeviceId(devId);
  };

  // 4) "View" => fetch violations for the insp + device
  const handleViewViolations = async () => {
    if (!selectedInspectionId || !selectedDeviceId) return;
    try {
      const url = `${API_BASE_URL}/api/violations/byInspectionAndDevice/${selectedInspectionId}/${selectedDeviceId}`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) {
        throw new Error(`Failed to fetch violations. Status: ${res.status}`);
      }
      const data = await res.json();
      setViolations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching violations:', err);
      setViolations([]);
    }
  };

  // 5) "Refresh" after add/edit
  const handleRefreshViolations = async () => {
    if (!selectedInspectionId || !selectedDeviceId) return;
    try {
      const url = `${API_BASE_URL}/api/violations/byInspectionAndDevice/${selectedInspectionId}/${selectedDeviceId}`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) {
        throw new Error(`Failed to refresh violations. Status: ${res.status}`);
      }
      const data = await res.json();
      setViolations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error refreshing violations:', err);
    }
  };

  // Find the selected inspection from the list
  const selectedInspectionObj =
    inspections.find((insp) => insp.inspectionId === parseInt(selectedInspectionId, 10)) || {};

  // If your server uses buildingSiteStored vs. buildingSite, adapt this line:
  const buildingSite = selectedInspectionObj.buildingSiteStored || '';
  const agencyId = selectedInspectionObj.agencyId || null;
  const inspectionNumber = selectedInspectionObj.inspectionNumber || '';

  return (
   <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <div className="flex flex-row gap-4 h-full pt-4">
        {/* LEFT COLUMN => form */}
        <div
          className="w-full md:w-3/12 lg:w-2/12 bg-white border border-gray-200 rounded-md p-4"
          style={{ minWidth: '250px' }}
        >
          <ViolationsForm
            inspectionId={selectedInspectionId}
            deviceId={selectedDeviceId}
            onRefreshViolations={handleRefreshViolations}
            inspectionNumber={inspectionNumber}
            buildingSite={buildingSite}
            agencyId={agencyId}
          />
        </div>

        {/* RIGHT COLUMN => table */}
        <div className="flex-1">
          <div className="bg-white border border-gray-200 rounded-md p-4 h-full">
            <ViolationsTable
              violations={violations}
              inspections={inspections}
              selectedInspectionId={selectedInspectionId}
              onSelectInspection={handleSelectInspection}
              devices={devices}
              selectedDeviceId={selectedDeviceId}
              onSelectDevice={handleSelectDevice}
              onViewViolations={handleViewViolations}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
